// Definitions
(function() {

    if (typeof window.SITE === "undefined") {
      window.SITE = {};
    }
  
    SITE.threeBlockAdjust = function() {

        $('.card__rows').each(function () {
            var cardHeight = 0;
            var titleHeight = 0;
            var cards = $(this).find('.card');
            var titles = $(this).find('.card__title');
        
            titles.each(function () {
                if($(this).height() > titleHeight) {
                    titleHeight = $(this).height();
                }
            });

            titles.height(titleHeight);

            cards.each(function () {
                if($(this).height() > cardHeight) {
                    cardHeight = $(this).height();
                }
            });

            cards.height(cardHeight);
        });
    }
})();
  
// Invocations
$(document).ready(function () {
    setTimeout(function() {
        SITE.threeBlockAdjust();
    }, 1000);
})